module.exports = __webpack_public_path__ + "static/media/li-5.19240651.png";